var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPig = function SvgPig(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 21,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4D5A6A",
    d: "M6 18.7V21h6v-2h1v2h6v-3.3c1.9-1.3 3-3.5 3-5.7 0-1.2-.3-2.3-.8-3.3C22.3 8.2 23 7.2 23 6h-2c0 .6-.4 1-1 1v.1C18.7 5.8 17 5 15 5h-4.2c-.4-1.4-1.7-2.7-4.7-3L5 1.9v3.8C3.6 6.4 2.4 7.6 1.7 9H0v5.6l2 1c.9 1.5 2.3 2.6 4 3.1M2 11h1.1l.2-.7c.3-.9.9-1.7 1.7-2.3h2V4.2c1.7.4 2 1.3 2 2.2V7h6c2.8 0 5 2.2 5 5 0 1.8-1 3.4-2.5 4.3l-.5.3V19h-2v-2h-5v2H8v-1.9l-.8-.1c-1.5-.3-2.8-1.2-3.6-2.5l-.1-.3-1.5-.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#4D5A6A",
    d: "M14 4a2 2 0 1 0 0-4 2 2 0 0 0 0 4"
  })));
};
export default SvgPig;